import {
    getStatusMappings,
    movementTranscationStatus,
} from "../../../tables/transactions-table/columns/movementsTypeCell"
import { TableMovementType } from "../../../tables/transactions-table/data/types"
import { Heading5, Heading6 } from "../../../ui/texts/TextStyle"

const TransactionStatusRow = ({
    status,
    type,
}: {
    status: movementTranscationStatus
    type: TableMovementType
}) => {
    const { icons, translations, descriptions } = getStatusMappings(type)

    return (
        <div className="flex flex-col bg-background-subtle mb-6 border border-border p-md rounded-md gap-betweenComponents">
            <div className={`flex flex-row items-center text-text `}>
                <>
                    <div className="size-fit pr-betweenComponents">{icons[status]}</div>
                    <div className="flex flex-col">
                        <Heading5 className="font-medium pb-[4px]">
                            {translations[status]}
                        </Heading5>

                        <Heading6 className="text-text-muted font-medium">
                            {descriptions[status]}
                        </Heading6>
                    </div>
                </>
            </div>
        </div>
    )
}

export default TransactionStatusRow
